import { createReducer } from '@reduxjs/toolkit';
import * as commentActions from './actions';
import { CommentState } from './model';

const initialState: CommentState = {
  comments: {},
  inProgress: {},
  editingComment: undefined,
  newComment: { assetId: undefined, content: '' },
};

export const commentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(commentActions.setInProgress, (s, a) => {
      if (a.payload.inProgress) {
        s.inProgress[a.payload.assetId] = true;
      } else {
        delete s.inProgress[a.payload.assetId];
      }
    })
    .addCase(commentActions.commentsLoaded, (s, a) => {
      s.comments[a.payload.assetId] = a.payload.comments;
    })
    .addCase(commentActions.setEditingComment, (s, a) => {
      s.editingComment = a.payload;
    })
    .addCase(commentActions.setNewComment, (s, a) => {
      s.newComment = a.payload;
    });
});
